import type { IAfterGuiAttachedParams, IDoesFilterPassParams, IFilterComp, IFilterParams } from 'ag-grid-community';
import { WPTicket } from "../../../_models/ticket.interface";
import { Technician } from "../../../_models";

export class DispatcherFilter implements IFilterComp<WPTicket> {
  filterParams!: IFilterParams;
  selectedDispatcherIds: Set<number> = new Set();
  noDispatcherSelected: boolean = false;
  gui!: HTMLDivElement;
  dispatchers: Technician[] = [];

  init(params: IFilterParams & { dispatchers: Technician[] }) {
    this.filterParams = params;
    this.dispatchers = params.dispatchers || [];
    this.setupGui(params);
  }

  setupGui(params: IFilterParams) {
    this.gui = document.createElement('div');

    let checkboxesHtml = `
      <div class="dispatcher-filter" style="padding: 8px;">
        <div style="display: flex; flex-direction: column; gap: 4px;">
          <div style="display: flex; flex-direction: row; align-items: center;">
            <input type="checkbox" id="no_dispatcher_checkbox" style="margin-right: 6px;"/>
            <label for="no_dispatcher_checkbox" style="margin: 0; cursor: pointer;">Kein Dispatcher</label>
          </div>
    `;

    this.dispatchers.forEach((dispatcher, index) => {
      checkboxesHtml += `
        <div style="display: flex; flex-direction: row; align-items: center;">
          <input type="checkbox" id="dispatcher_${dispatcher.id}" style="margin-right: 6px;"/>
          <label for="dispatcher_${dispatcher.id}" style="margin: 0; cursor: pointer;">${dispatcher.name}</label>
        </div>
      `;
    });

    checkboxesHtml += `
        </div>
      </div>
    `;

    this.gui.innerHTML = checkboxesHtml;

    // Add listener for "Kein Dispatcher"
    const noDispatcherCheckbox = this.gui.querySelector('#no_dispatcher_checkbox');
    noDispatcherCheckbox?.addEventListener('change', (event: any) => {
      this.noDispatcherSelected = event.target.checked;
      params.filterChangedCallback();
    });

    // Add listeners for each dispatcher
    this.dispatchers.forEach(dispatcher => {
      const checkbox = this.gui.querySelector(`#dispatcher_${dispatcher.id}`);
      checkbox?.addEventListener('change', (event: any) => {
        if (event.target.checked) {
          this.selectedDispatcherIds.add(dispatcher.id);
        } else {
          this.selectedDispatcherIds.delete(dispatcher.id);
        }
        params.filterChangedCallback();
      });
    });
  }

  getGui() {
    return this.gui;
  }

  doesFilterPass(params: IDoesFilterPassParams<WPTicket>) {
    const { node } = params;
    const ticket = node.data;

    // If no filters are active, pass all
    if (!this.isFilterActive()) {
      return true;
    }

    // Check if ticket has no dispatcher and "Kein Dispatcher" is selected
    if (this.noDispatcherSelected && !ticket.dispatcher) {
      return true;
    }

    // Check if ticket dispatcher is in selected dispatchers
    return ticket.dispatcher && this.selectedDispatcherIds.has(ticket.dispatcher.id);


  }

  isFilterActive() {
    return this.noDispatcherSelected || this.selectedDispatcherIds.size > 0;
  }

  getModel() {
    return {
      selectedDispatcherIds: Array.from(this.selectedDispatcherIds),
      noDispatcherSelected: this.noDispatcherSelected
    };
  }

  setModel(model: any) {
    if (model) {
      this.selectedDispatcherIds = new Set(model.selectedDispatcherIds || []);
      this.noDispatcherSelected = model.noDispatcherSelected || false;
    }
  }

  afterGuiAttached(params?: IAfterGuiAttachedParams): void {
  }
}
